//global variables
export const config = {
    //backendURL : "http://localhost"
    backendURL: "https://admin.ticketmojo.co.ke"
}